import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { useAuth } from "../contexts/AuthContext";
import { L, t } from "../lib/translations";

export function Footer() {
  const { lang } = useLanguage();
  const { user } = useAuth();
  const year = new Date().getFullYear();

  const LINKS = [
    { to: "/shop",    label: t("Admin.shop", lang) },
    { to: "/faq",     label: t("c.Footer.faq", lang) },
    { to: "/contact", label: t("c.Footer.contact", lang) },
    { to: "/terms",   label: t("c.Footer.terms", lang) },
    { to: "/warranty",label: t("c.Footer.warranty", lang) },
    { to: "/privacy", label: t("c.Footer.privacy", lang) },
    ...(user ? [
      { to: "/dashboard", label: t("c.Footer.dashboard", lang) },
      { to: "/topup",     label: t("nav.topup", lang) },
    ] : []),
  ];

  return (
    <footer
      className="border-t mt-auto pt-8 px-6 pb-8 md:pb-8"
      style={{ borderColor: "var(--border-color)", background: "var(--bg-secondary)" }}
      data-testid="site-footer"
    >
      <div className="max-w-5xl mx-auto space-y-6 flex flex-col items-center text-center">

        {/* Brand */}
        <Link to="/">
          <span className="text-xl font-black font-outfit" style={{ color: "#8B5CF6" }}>iFollowers</span>
        </Link>

        {/* Navigation links */}
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2">
          {LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="text-xs font-medium transition-colors hover:text-[#8B5CF6]"
              style={{ color: "var(--text-secondary)" }}
            >
              {label}
            </Link>
          ))}
        </div>

        {/* Copyright */}
        <p className="text-[11px]" style={{ color: "var(--text-secondary)" }}>
          © {year} iFollowers — {t("c.Footer.all_rights_reserved", lang)}
        </p>

      </div>
    </footer>
  );
}
